// Copyright (c) 2020 Deere & Company

import actions from '../../actions-list';
import {stripSpaces} from '../../../shared/services/strip-spaces';

export const updatePartCoverageSearchCriteria = (attribute, value) =>
    dispatch => {

        let processedValue;

        processedValue = value;

        if (attribute === 'partNumber' || attribute === 'pin') {

            processedValue = stripSpaces(processedValue.toUpperCase());

        }

        dispatch({
            attribute,
            type: actions.UPDATE_PART_COVERAGE_SEARCH_CRITERIA,
            value: processedValue
        });

    };



// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/action-creators/criteria.js